var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconDisability64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_17154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7697 51.3134V27.9054C46.7697 25.0708 44.4609 22.7729 41.6129 22.7729H22.1211",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4458 8.50269H22.1214V34.1513",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6079 37.0432H53.2565C53.973 37.0432 54.5538 37.624 54.5538 38.3405V40.9351C54.5538 41.6516 53.973 42.2324 53.2565 42.2324H28.6079V37.0432Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.77 56.5837C49.2777 56.5837 51.3106 54.5509 51.3106 52.0432C51.3106 49.5356 49.2777 47.5027 46.77 47.5027C44.2624 47.5027 42.2295 49.5356 42.2295 52.0432C42.2295 54.5509 44.2624 56.5837 46.77 56.5837Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9458 56.5027C28.2971 56.5027 33.4458 51.354 33.4458 45.0027C33.4458 38.6514 28.2971 33.5027 21.9458 33.5027C15.5945 33.5027 10.4458 38.6514 10.4458 45.0027C10.4458 51.354 15.5945 56.5027 21.9458 56.5027Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_17154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconDisability64);
export default __webpack_public_path__ + "static/media/pictogramBeaconDisability64.87f78626e9b40799422ace8f4caed648.svg";
export { ForwardRef as ReactComponent };